// Core
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Plugins
import { isModuleEntitled } from '../plugins/entitlements';

/**
 * Route guard for optional modules. Renders the route when the customer is entitled to
 * the module, otherwise redirects silently to redirectTo.
 */
const EntitledRoute = (props) => {
  const {
    customer, module: moduleKey, redirectTo, component: Component, ...routeProps
  } = props;

  if (!isModuleEntitled(customer, moduleKey)) {
    return (
      <Route {...routeProps}>
        <Redirect to={redirectTo} />
      </Route>
    );
  }

  return <Route {...routeProps} component={Component} />;
};

EntitledRoute.propTypes = {
  customer: PropTypes.object,
  module: PropTypes.string.isRequired,
  redirectTo: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
};

EntitledRoute.defaultProps = {
  customer: null,
};

const mapStateToProps = (state) => ({
  customer: state.session.customer,
});

export default connect(mapStateToProps)(EntitledRoute);
